import type { ICreditDecisionLender, Lender, LenderAddress } from '@makemydeal/dr-platform-types';

export enum LenderType {
    Dealertrack = 'Dealertrack',
    External = 'External'
}

export enum ContractType {
    Digital = 'Digital',
    Paper = 'Paper'
}

export enum ApplicantType {
    Consumer = 'Consumer',
    Business = 'Business',
    BusinessWithGuarantor = 'BusinessWithGuarantor',
    BusinessWithCoApplicant = 'BusinessWithCoApplicant'
}

export type LenderListState = (Lender &
    LenderAddress & {
        lenderType?: LenderType;
        contractType?: ContractType;
    })[];

export type SelectedLenderWithAddress = ICreditDecisionLender & LenderAddress;
